<template>
  <div class="card mb-4 cursor-pointer min-w-0"
       data-testid="kss-task-card"
       :data-series-id="createdTask?.seriesId || createdTask?._id"
       :data-series-name="createdTask?.name"
       :class="{'task-card__disabled': editable === false && showContainer === false,
           'task-item__disabled': editable === false && showContainer === true}">
    <div class="flex flex-row flex-wrap sm:flex-nowrap items-stretch sm:items-center p-2 sm:p-3 gap-2 min-w-0" @click.prevent="toogleDetails" data-testid="kss-task-card-header">
      <div class="flex flex-col flex-1 min-w-0 order-1">
        <h3 class="text-base sm:text-lg truncate break-words">
          {{ $t("KssTaskCreatedComponent.collaborationTracker", { text: featureName, name: createdTask?.name }) }}
        </h3>
        <div v-if="taskIsRecurring" class="text-[var(--color-orange)] text-sm sm:text-base mt-0.5 flex items-center gap-1 flex-wrap">
          <font-awesome-icon icon="fa-repeat" class="shrink-0"/>
          <span>{{ displayRecurrenceLabel }}</span>
        </div>
        <div v-if="taskIsRecurring" class="text-sm sm:text-base mt-0.5 text-gray-600 flex flex-wrap gap-x-3 gap-y-1">
          <span>
            {{ $t('kssSeriesDisplay.seriesEnd') }}:
            <strong>{{ displaySeriesEnd }}</strong>
          </span>
          <span>
            {{ $t('kssSeriesDisplay.plannedEvents', { count: plannedScheduledCount }) }}
          </span>
        </div>
        <div v-if="savedParticipantCount > 0" class="flex items-center flex-wrap gap-x-2 mt-1 min-w-0 text-sm sm:text-base">
          <font-awesome-icon icon="fa-users" class="shrink-0"/>
          <span class="font-normal break-words">{{ savedParticipantCount + ' ' + $t('KssTaskCreatedComponent.participants', savedParticipantCount) }} |</span>
          <span class="font-normal" :style="percentTextColor">{{ participantsPercent }}</span>
        </div>
        <div class="flex flex-wrap items-center gap-2 mt-1 min-w-0">
          <div class="text-[var(--color-white)] flex flex-row bg-[var(--color-orange)] py-1 px-2.5 items-center min-h-0 w-min rounded shrink-0">
            <font-awesome-icon icon="fa-calendar" class="shrink-0 w-4 sm:w-5"/>
            <span class="py-0.5 px-1 text-xs sm:text-sm">{{ savedTaskDateLabel }}</span>
          </div>
          <div v-if="createdTask?.outlook_id" class="flex flex-row text-[var(--color-white)] bg-[var(--color-orange)] py-1 px-2.5 items-center min-h-0 w-min rounded shrink-0">
            <span class="py-0.5 px-1 text-xs sm:text-sm">Outlook</span>
          </div>
        </div>
        <div v-if="createdTask?.outlook_id" class="text-center py-1 px-2 mt-1 text-xs sm:text-sm italic text-[#aaa] hidden md:block">
          {{ $t('kss_guideline_text') }}
        </div>
      </div>
      <div class="flex items-center order-2 sm:order-3 flex-shrink-0 self-center">
        <font-awesome-icon
          v-if="!showContainer"
          icon="fa-solid fa-chevron-down"
          class="text-gray-400 hover:text-gray-600 transition-colors" />
        <font-awesome-icon
          v-else
          icon="fa-solid fa-chevron-up"
          class="text-gray-400 hover:text-gray-600 transition-colors" />
      </div>
    </div>
    <div v-show="showContainer" class="flex flex-col border-t pt-4">
      <div class="block box-border py-5 px-4 sm:px-7">
        <Form @submit="updateKssTask">
            <div class="p-0 my-0 mx-auto box-border">
              <div class="flex flex-wrap">
                <label for="cbox1" class="block text-center w-80 py-1 px-3 mx-auto text-lg
                font-medium text-[--color-orange] cursor-pointer" id="lbl_calDate"
                       @click.prevent="toggleShowCalendar">
                  <font-awesome-icon icon="fa-calendar"/>
                  {{ formattedStartDate ?? $t('KssRuntimeComponent.selectDate') }}
                </label>
                <div class="order-last flex-grow w-full" id="div_calendar-date"
                    v-if="showCalendar">
                  <edit-kss-calendar-component v-if="createdTask"
                                               :key="calendarComponentKey"
                                               :editable="editable"
                                               :initialDate="selectedDate"
                                               @updateDate="updateSelectedDate"/>
                </div>
                <label for="cbox2" class="block text-center w-80 py-1 px-3 mx-auto text-lg
                    font-medium text-[--color-orange] cursor-pointer"
                    id="lbl_cal-time" @click.prevent="toggleShowRuntime">
                  <font-awesome-icon icon="fa-clock"/>
                  {{ formattedTime ?? $t('KssRuntimeComponent.selectRuntime') }}
                </label>
                <div class="order-last flex-grow w-full" id="div_calendar-time"
                    v-if="showRuntime">
                  <div class="mt-4 rounded-lg bg-white p-8 border border-[#e2e8f0]"
                    id="div_runtime">
                    <edit-kss-runtime-component v-if="createdTask"
                                                :key="runtimeComponentKey"
                                                :editable="editable"
                                                :initialDate="getRuntimeDate"
                                                :initialRecurring="repeatRules[0]"
                                                :initialIncludeWeekends="createdTask?.includeWeekends"
                                                @updateTime="updateSelectedTime"
                                                @updateReccuring="updateReccuring"
                                                :is-start-time="false"/>
                  </div>
                </div>
              </div>
            </div>
            <edit-kss-form-component :editable="editable"
                                     :initialSubject="meetingSubject"
                                     :initialDescription="meetingDescription"
                                     :involvedUsers="createdTask.involvedUsers"
                                     :allKssParticipants="allKssParticipants"
                                     :allInvolvedKssUsers="involvedKssUsers"
                                     :selectedIds="selectedUsers"
                                     :externalUsers="externalUsers"
                                     :KssTeams="KssTeams"
                                     @updateSubject="updateSubject"
                                     @updateDescription="updateDescription"
                                     @updateSelectedUserIds="updateSelectedUsers"
                                     @updateExternalUsers="updateExternalUsers"/>
        </Form>
      </div>
      <div v-if="editable !== false" class="w-full pt-4 sm:pt-8 box-border flex flex-col-reverse sm:flex-row justify-end gap-2 sm:gap-0 px-4 sm:px-7 pb-2">
        <Button
          v-if="taskIsRecurring && !seriesIsEnded"
          class="text-amber-700 bg-none rounded-full w-full sm:w-fit min-h-10 my-0 mx-0 sm:mx-4 px-4 py-2 text-sm sm:text-base hover:text-amber-900"
          data-testid="kss-end-series-button"
          :label="$t('KssTaskCreatedComponent.endSeriesButton')"
          @click.prevent="endSeries"
          icon="pi pi-stop-circle"
          unstyled/>
        <Button class="text-red-600 bg-none rounded-full w-full sm:w-fit min-h-10 my-0 mx-0 sm:mx-4 px-4 py-2 text-sm sm:text-base hover:text-red-700"
          :label="$t('KssTaskCreatedComponent.popup.deleteButton')"
          data-testid="kss-delete-button"
          @click.prevent="deleteTask" icon="pi pi-trash" unstyled/>
        <Button class="btn-primary-accent w-full sm:w-fit min-h-fit my-0 mx-0 sm:mx-4 px-6 py-2 text-sm sm:text-base"
          data-testid="kss-update-button"
          :disabled="editable === false || isSavingKssUpdate"
          :class="(editable === false || isSavingKssUpdate) && 'disabled'"
          :loading="isSavingKssUpdate"
          @click.prevent="updateKssTask" unstyled>
          {{ $t('KssTaskCreatedComponent.updateTask') }}
        </Button>
      </div>
      <div class="flex flex-row flex-wrap items-center px-4 sm:px-7" v-if="this.isTaskScheduledToReoccur">
        <h4 class="mr-2">
          {{
            $t('kssSeriesDisplay.nextEventsPreview', {
              shown: previewTaskEvents.length,
              total: plannedScheduledCount,
            })
          }}
        </h4>
        <div>
          <div
            class="flex items-center justify-around w-full bg-[var(--color-orange)] rounded-2xl py-1
                px-3 m-1 text-sm text-[var(--color-white)]"
            v-for="taskEvent in previewTaskEvents"
            :key="taskEvent._id || taskEvent.date_eventBegin"
            @click="handleCancelledTaskEventsAction(taskEvent)"
            :class="{ 'bg-gray-600': isCancelledTaskEvent(taskEvent) }"
          >
            {{ getFormattedDate(taskEvent.date_eventBegin) }}
            <font-awesome-icon class="ml-3" v-if="isCancelledTaskEvent(taskEvent)"
                               icon="fa-arrows-rotate"/>
            <font-awesome-icon class="ml-3" v-else icon="fa-trash-can"/>
          </div>
        </div>
      </div>
    </div>
    <Dialog
      v-model:visible="showEditScopeDialog"
      modal
      :header="$t('KssTaskCreatedComponent.editScope.title')"
      :style="{ width: 'min(28rem, 95vw)' }"
      :closable="true">
      <p class="text-sm text-gray-600 mb-4">
        {{ $t('KssTaskCreatedComponent.editScope.message') }}
      </p>
      <div class="flex flex-col gap-3">
        <label class="flex items-start gap-2 cursor-pointer" data-testid="kss-edit-scope-occurrence">
          <input
            v-model="selectedEditScope"
            type="radio"
            class="mt-1"
            value="occurrence"
            data-testid="kss-edit-scope-occurrence-input">
          <span>
            <strong>{{ $t('KssTaskCreatedComponent.editScope.occurrence') }}</strong>
            <span class="block text-sm text-gray-600">
              {{ $t('KssTaskCreatedComponent.editScope.occurrenceHint') }}
            </span>
          </span>
        </label>
        <label class="flex items-start gap-2 cursor-pointer" data-testid="kss-edit-scope-future">
          <input
            v-model="selectedEditScope"
            type="radio"
            class="mt-1"
            value="future"
            data-testid="kss-edit-scope-future-input">
          <span>
            <strong>{{ $t('KssTaskCreatedComponent.editScope.future') }}</strong>
            <span class="block text-sm text-gray-600">
              {{ $t('KssTaskCreatedComponent.editScope.futureHint') }}
            </span>
          </span>
        </label>
        <label class="flex items-start gap-2 cursor-pointer" data-testid="kss-edit-scope-series">
          <input
            v-model="selectedEditScope"
            type="radio"
            class="mt-1"
            value="series"
            data-testid="kss-edit-scope-series-input">
          <span>
            <strong>{{ $t('KssTaskCreatedComponent.editScope.series') }}</strong>
            <span class="block text-sm text-gray-600">
              {{ $t('KssTaskCreatedComponent.editScope.seriesHint') }}
            </span>
          </span>
        </label>
      </div>
      <template #footer>
        <Button
          :label="$t('KssTaskCreatedComponent.popup.cancelButton')"
          severity="secondary"
          outlined
          :disabled="isSavingKssUpdate"
          @click="showEditScopeDialog = false"/>
        <Button
          data-testid="kss-edit-scope-confirm"
          :label="$t('KssTaskCreatedComponent.updateTask')"
          :disabled="isSavingKssUpdate"
          :loading="isSavingKssUpdate"
          @click="confirmEditScopeAndSave"/>
      </template>
    </Dialog>
  </div>
</template>

<script>
import EditKssCalendarComponent
  from '@/components/Home/KssCreator/KssEditComponents/EditKssCalendarComponent.vue';
import EditKssRuntimeComponent
  from '@/components/Home/KssCreator/KssEditComponents/EditKssRuntimeComponent.vue';
import EditKssFormComponent
  from '@/components/Home/KssCreator/KssEditComponents/EditKssFormComponent.vue';
import { Button } from 'primevue';
import Dialog from 'primevue/dialog';
import { Form } from '@primevue/forms';
import {
  formatKssRecurrenceLabel,
  formatKssSeriesEnd,
  formatKssSeriesScheduleTime,
  getKssPlannedScheduledCount,
} from '@/helpers/kssSeriesDisplay';
import {
  getKssOccurrenceParticipantIds,
  kssOccurrenceMinuteKey,
  sortKssUserIds,
} from '@/helpers/kssOccurrenceRoster';

const UPCOMING_PREVIEW_LIMIT = 6;
import { getFeatureDisplayNameOrFallback } from '@/utils/featureDisplay';

export default {
  name: 'KssTaskCreatedComponent',
  components: {
    EditKssFormComponent,
    EditKssRuntimeComponent,
    EditKssCalendarComponent,
    Button,
    Dialog,
    Form,
  },
  props: ['createdTask', 'allKssParticipants', 'involvedKssUsers'],
  data() {
    return {
      currentTaskEvents: [],
      showPopup: false,
      showContainer: false,
      showRuntime: false,
      showCalendar: false,
      selectedHours: null,
      selectedMinutes: null,
      /** Set from `initEditOccurrenceFromTask` (anchor from saved `createdTask`). */
      selectedDate: null,
      /** Original occurrence anchor before the user edits time (for editScope). */
      editOccurrenceDate: null,
      showEditScopeDialog: false,
      selectedEditScope: 'occurrence',
      repeatRules: [],
      reccurringObject: null,
      selectedUsers: this.createdTask.involvedUsers,
      /** Slot occupants used as dirty-check baseline (may differ from series involvedUsers). */
      occurrenceParticipantBaseline: [...(this.createdTask.involvedUsers || [])],
      /** True after the user changes the Multiselect / team selection. */
      participantsTouched: false,
      /** Guards against double-submit on scope confirm / save. */
      isSavingKssUpdate: false,
      meetingSubject: this.createdTask.name,
      meetingDescription: this.createdTask.description,
      KssTeams: this.$store.getters.getTeamsForSelection,
      externalUsers: [],
      popupMessage: this.$t('KssTaskCreatedComponent.popup.deleteMessage'),
      deleteButtonText: this.$t('KssTaskCreatedComponent.popup.deleteButton'),
      cancelButtonText: this.$t('KssTaskCreatedComponent.popup.cancelButton'),
      minCount: this.$store.getters.getMinCount,
    };
  },
  computed: {
    featureName() {
      return getFeatureDisplayNameOrFallback(
        this.$store,
        'kssTracker',
        this.$t('FallbackTexts.collaborationTracker'),
        this.$i18n?.locale,
      );
    },
    editable() {
      return this.createdTask.editable;
    },
    isTaskScheduledToReoccur() {
      if (this.repeatRules?.[0]?.frequency === 'MINUTELY') {
        return false;
      }
      return true;
    },
    formattedStartDate() {
      return this.formatCalendarDay(this.selectedDate);
    },
    /** Clock label = series SoT from kss_series (`repeatRules[0].start`), not occurrence exception. */
    formattedTime() {
      const seriesTime = formatKssSeriesScheduleTime(this.createdTask);
      if (seriesTime) return seriesTime;
      if (this.selectedHours == null || this.selectedMinutes == null) {
        return '';
      }
      return `${(`0${this.selectedHours}`).slice(-2)}:${(`0${this.selectedMinutes}`).slice(-2)}`;
    },
    getRuntimeDate() {
      if (!this.selectedDate || typeof this.selectedDate.getFullYear !== 'function') {
        return new Date();
      }
      return new Date(
        this.selectedDate.getFullYear(),
        this.selectedDate.getMonth(),
        this.selectedDate.getDate(),
        this.selectedHours ?? 0,
        this.selectedMinutes ?? 0,
      );
    },
    /** Collapsed card: `createdTask` only (unchanged until save). */
    taskIsRecurring() {
      const rule = this.createdTask?.repeatRules?.[0];
      return !!(rule && rule.frequency !== 'MINUTELY');
    },
    seriesIsEnded() {
      return this.createdTask?.seriesEnded === true || this.createdTask?.status === 'ended';
    },
    savedTaskDateLabel() {
      return this.formatCalendarDay(this.anchorDateFromTask(this.createdTask));
    },
    savedRecurrenceLabel() {
      return this.recurrenceTypeLabel(this.createdTask?.repeatRules?.[0]);
    },
    displayRecurrenceLabel() {
      return formatKssRecurrenceLabel(this.createdTask, (key, params) => this.$t(key, params));
    },
    displaySeriesEnd() {
      return formatKssSeriesEnd(this.createdTask, (key) => this.$t(key));
    },
    plannedScheduledCount() {
      return getKssPlannedScheduledCount(this.createdTask);
    },
    previewTaskEvents() {
      return this.currentTaskEvents.slice(0, UPCOMING_PREVIEW_LIMIT);
    },
    savedParticipantCount() {
      return this.createdTask?.involvedUsers?.length || 0;
    },
    calendarComponentKey() {
      const d = this.selectedDate;
      if (!d || typeof d.getTime !== 'function') return 'kss-cal';
      return `kss-cal-${d.getTime()}`;
    },
    runtimeComponentKey() {
      // Key only on occurrence datetime — do not include repeatRules signature.
      // Including rules remounted the editor when switching non-recurring → weekly and wiped day chips.
      const d = this.selectedDate;
      if (!d || typeof d.getTime !== 'function') {
        return `kss-rt-${this.selectedHours}-${this.selectedMinutes}`;
      }
      return `kss-rt-${d.getTime()}-${this.selectedHours}-${this.selectedMinutes}`;
    },
    participantsPercent() {
      if (this.savedParticipantCount >= this.minCount) {
        return `${Number(this.createdTask.percent).toFixed(2)}% ${this.$t('KssTaskCreatedComponent.completed')}`;
      }
      return this.$t('KssTaskArchivedComponent.lessParticipants', { count: this.minCount });
    },
    percentTextColor() {
      if (this.savedParticipantCount >= this.minCount) {
        return 'color: var(--color-orange)';
      }
      return 'color: var(--color-disabled)';
    },
  },
  watch: {
    involvedKssUsers: {
      deep: true,
      handler() {
        this.loadExternalEmailsFromInvolved();
      },
    },
    createdTask: {
      deep: true,
      immediate: true,
      handler(newTask) {
        if (!newTask) return;
        this.syncCurrentTaskEventsFromProp();
        this.repeatRules = JSON.parse(
          JSON.stringify(newTask.repeatRules || [{ frequency: 'MINUTELY' }]),
        );
        if (
          newTask.seriesEndDate
          && this.repeatRules[0]
          && this.repeatRules[0].frequency !== 'MINUTELY'
          && !this.repeatRules[0].end
        ) {
          this.repeatRules[0].end = newTask.seriesEndDate;
        }
        this.reccurringObject = null;
        this.initEditOccurrenceFromTask();
        this.seedSelectedUsersForEditOccurrence({ force: true });
        this.meetingSubject = newTask.name;
        this.meetingDescription = newTask.description;
        this.loadExternalEmailsFromInvolved();
      },
    },
  },
  created() {
    this.repeatRules = JSON.parse(
      JSON.stringify(this.createdTask.repeatRules || [{ frequency: 'MINUTELY' }]),
    );
    this.syncCurrentTaskEventsFromProp();
    this.initEditOccurrenceFromTask();
    this.seedSelectedUsersForEditOccurrence({ force: true });
  },
  methods: {
    formatCalendarDay(d) {
      if (!d || typeof d.getFullYear !== 'function') return '';
      return `${(`0${d.getDate()}`).slice(-2)}.${(`0${d.getMonth() + 1}`).slice(-2)}.${d.getFullYear()}`;
    },
    getSeriesParticipantIds() {
      return [...(this.createdTask?.involvedUsers || [])].map(String);
    },
    /**
     * Series schedule anchor for recurring series/future payloads — keep config start day so browsing
     * a future occurrence in the calendar does not rewrite repeatRules.start.
     * Not used for one-time (MINUTELY) updates — those must use the picker date.
     */
    getSeriesScheduleDateTaskBegin() {
      const raw = this.createdTask?.repeatRules?.[0]?.start;
      if (raw == null) return this.getCurrentDateTaskBegin();
      const base = new Date(raw);
      if (Number.isNaN(base.getTime())) return this.getCurrentDateTaskBegin();
      return new Date(
        base.getFullYear(),
        base.getMonth(),
        base.getDate(),
        this.selectedHours ?? base.getHours(),
        this.selectedMinutes ?? base.getMinutes(),
        0,
        0,
      );
    },
    /**
     * Prefer an existing taskEvent matching the selected datetime (or same local day).
     * Lets occurrence/future edits target the browsed meeting instead of the open-anchor.
     */
    findTaskEventForSelectedDate() {
      const current = this.getCurrentDateTaskBegin();
      if (!current) return null;
      const events = this.createdTask?.taskEvents || this.currentTaskEvents || [];
      const currentKey = kssOccurrenceMinuteKey(current);
      const exact = events.find(
        (e) => e && kssOccurrenceMinuteKey(e.date_eventBegin) === currentKey,
      );
      if (exact) return exact;

      const y = current.getFullYear();
      const m = current.getMonth();
      const d = current.getDate();
      return events.find((e) => {
        if (!e?.date_eventBegin) return false;
        const ed = new Date(e.date_eventBegin);
        return ed.getFullYear() === y && ed.getMonth() === m && ed.getDate() === d;
      }) || null;
    },
    /**
     * Occupants of the occurrence under edit (Fix A slot roster).
     * Falls back to series roster when the slot is not in taskEvents yet.
     */
    getOccurrenceParticipantIds(dateVal) {
      return getKssOccurrenceParticipantIds({
        seriesParticipantIds: this.getSeriesParticipantIds(),
        taskEvents: this.createdTask?.taskEvents || this.currentTaskEvents || [],
        occurrenceDate: dateVal,
      });
    },
    seedSelectedUsersForEditOccurrence({ force = false } = {}) {
      if (!force && this.participantsTouched) return;
      const matched = this.findTaskEventForSelectedDate();
      const anchor = matched?.date_eventBegin
        ? new Date(matched.date_eventBegin)
        : (this.editOccurrenceDate
          || this.getCurrentDateTaskBegin()
          || this.anchorDateFromTask(this.createdTask));
      const ids = this.getOccurrenceParticipantIds(anchor);
      this.occurrenceParticipantBaseline = [...ids];
      this.selectedUsers = [...ids];
      this.participantsTouched = false;
      if (this.showContainer) {
        this.$store.commit('syncKssEditSelectionFromInvolvedUserIds', ids);
      }
    },
    recurrenceTypeLabel(rule) {
      if (!rule) return this.$t('KssRecurringTaskComponent.daily');
      if (Object.prototype.hasOwnProperty.call(rule, 'interval')) {
        return this.$t('KssRecurringTaskComponent.custom');
      }
      if (rule.frequency === 'MONTHLY') return this.$t('KssRecurringTaskComponent.monthly');
      if (rule.frequency === 'WEEKLY') return this.$t('KssRecurringTaskComponent.weekly');
      return this.$t('KssRecurringTaskComponent.daily');
    },
    anchorDateFromTask(task) {
      if (!task) return null;

      const rules = task.repeatRules || [];
      const anchorFromRules =
        rules[0]?.start != null ? new Date(rules[0].start) : null;

      const raw = task.taskEvents || [];
      const events = [...raw]
        .filter((e) => e && e.date_eventBegin != null)
        .sort(
          (a, b) =>
            new Date(a.date_eventBegin).getTime() - new Date(b.date_eventBegin).getTime(),
        );

      const isCancelled = (e) => e.status === 'removed_from_series';

      let anchorDate = null;
      for (let i = 0; i < events.length; i += 1) {
        const ev = events[i];
        if (isCancelled(ev)) continue;
        if (ev.status === 'open' || ev.status === 'began' || ev.status === 'processed') {
          anchorDate = new Date(ev.date_eventBegin);
          break;
        }
        if (ev.status === 'scheduled') {
          anchorDate = new Date(ev.date_eventBegin);
          break;
        }
      }

      if ((!anchorDate || Number.isNaN(anchorDate.getTime())) && anchorFromRules
        && !Number.isNaN(anchorFromRules.getTime())) {
        anchorDate = anchorFromRules;
      }

      if (!anchorDate || Number.isNaN(anchorDate.getTime())) {
        const dc = task.date_created;
        anchorDate = dc ? new Date(dc) : new Date();
      }

      return anchorDate;
    },
    syncCurrentTaskEventsFromProp() {
      const events = this.createdTask?.taskEvents || [];
      this.currentTaskEvents = events
        .filter((e) => e.status === 'scheduled' || e.status === 'removed_from_series')
        .sort(
          (a, b) => new Date(a.date_eventBegin).getTime() - new Date(b.date_eventBegin).getTime(),
        );
    },
    /**
     * Sync `externalUsers` from the saved task + `involvedKssUsers`.
     * When the edit panel is closed, only persisted external invite emails are kept.
     * When the panel is open, extra addresses in `externalUsers` (typed, not yet saved) are merged in.
     */
    loadExternalEmailsFromInvolved() {
      const invitedIds = new Set((this.createdTask?.involvedUsers || []).map((id) => String(id)));
      const emailsFromParticipants = (this.involvedKssUsers || [])
        .filter(
          (u) => u && u.userStatus === 'external' && u.email && invitedIds.has(String(u._id)),
        )
        .map((u) => u.email);

      if (!this.showContainer) {
        this.externalUsers = [...emailsFromParticipants];
        return;
      }

      const knownLower = new Set(emailsFromParticipants.map((e) => String(e).toLowerCase()));
      const pending = (this.externalUsers || []).filter(
        (em) => em && !knownLower.has(String(em).toLowerCase()),
      );
      const seen = new Set(knownLower);
      const merged = [...emailsFromParticipants];
      pending.forEach((em) => {
        const lower = String(em).toLowerCase();
        if (!seen.has(lower)) {
          seen.add(lower);
          merged.push(em);
        }
      });
      this.externalUsers = merged;
    },
    initEditOccurrenceFromTask() {
      const anchorDate = this.anchorDateFromTask(this.createdTask);
      if (!anchorDate || Number.isNaN(anchorDate.getTime())) return;

      this.selectedDate = anchorDate;
      this.editOccurrenceDate = new Date(anchorDate.getTime());
      this.selectedHours = anchorDate.getHours();
      this.selectedMinutes = anchorDate.getMinutes();
    },
    updateSelectedDate(date) {
      this.selectedDate = date;
      // Browsing another occurrence: refresh slot roster unless the user already edited chips.
      this.seedSelectedUsersForEditOccurrence();
    },
    updateSelectedUsers(users) {
      this.selectedUsers = users;
      this.participantsTouched = true;
    },
    updateSelectedTime(time) {
      const hours = time.split(':')[0];
      const minutes = time.split(':')[1];
      this.selectedHours = Number(hours);
      this.selectedMinutes = Number(minutes);
    },
    updateReccuring(reccuringObject) {
      this.reccurringObject = reccuringObject;
    },
    updateSubject(subject) {
      this.meetingSubject = subject;
    },
    updateDescription(description) {
      this.meetingDescription = description;
    },
    updateExternalUsers(externalUsers) {
      this.externalUsers = externalUsers;
    },
    toogleDetails() {
      this.showContainer = !this.showContainer;
      if (this.showContainer) {
        this.meetingSubject = this.createdTask.name;
        this.meetingDescription = this.createdTask.description;
        this.loadExternalEmailsFromInvolved();
        this.seedSelectedUsersForEditOccurrence({ force: true });
      } else {
        this.loadExternalEmailsFromInvolved();
      }
    },
    toggleShowCalendar() {
      this.showCalendar = !this.showCalendar;
    },
    toggleShowRuntime() {
      this.showRuntime = !this.showRuntime;
    },
    endSeries() {
      this.$confirm.require({
        message: this.$t('KssTaskCreatedComponent.popup.endSeriesMessage'),
        header: 'Confirmation',
        icon: 'pi pi-exclamation-triangle',
        rejectProps: {
          label: this.$t('KssTaskCreatedComponent.popup.cancelButton'),
          severity: 'secondary',
          outlined: true,
        },
        acceptProps: {
          label: this.$t('KssTaskCreatedComponent.endSeriesButton'),
        },
        accept: this.onEndSeriesConfirm,
      });
    },
    async onEndSeriesConfirm() {
      const data = {
        seriesId: this.createdTask.seriesId || this.createdTask._id,
      };
      try {
        await this.$store.dispatch('endKssSeries', data);
        this.showContainer = false;
        this.$toast.add({
          severity: 'success',
          summary: this.$t('KssTaskCreatedComponent.toast.successfulEndSeries'),
          detail: '',
          life: 3000,
        });
      } catch (error) {
        this.$toast.add({
          severity: 'error',
          summary: error.response?.data?.message || this.$t('KssTaskCreatedComponent.toast.errorEndSeries'),
          detail: '',
          life: 3000,
        });
      }
    },
    deleteTask() {
      this.showPopup = true;
      this.$confirm.require({
        message: this.popupMessage,
        header: 'Confirmation',
        icon: 'pi pi-exclamation-triangle',
        rejectProps: {
          label: this.cancelButtonText,
          severity: 'secondary',
          outlined: true,
        },
        acceptProps: {
          label: this.deleteButtonText,
        },
        accept: this.onPopupConfirm,
        reject: this.onPopupCancel,
      });
    },
    onPopupCancel() {
      this.showPopup = false;
    },
    // added additional checks to allow to set time to 00 hours
    checkForErrors() {
      let hasError = false;

      if (!this.selectedDate) {
        this.$toast.add({
          severity: 'error',
          summary: this.$t('ToastComponent.kss.selectDateErr'),
          detail: '',
          life: 3000,
        });
        hasError = true;
      }

      if (!this.selectedHours && this.selectedHours !== 0) {
        this.$toast.add({
          severity: 'error',
          summary: this.$t('ToastComponent.kss.selectTimeErr'),
          detail: '',
          life: 3000,
        });
        hasError = true;
      }

      // allow only recurring tasks in the past to be edited
      // non recurring tasks should show an error if edited in the past
      if (this.selectedDate
        && (this.selectedHours || this.selectedHours === 0)
        && !this.checkDateAndTimeValid()
        && this.repeatRules?.[0]?.frequency === 'MINUTELY') {
        this.$toast.add({
          severity: 'error',
          summary: this.$t('ToastComponent.kss.pastDateErr'),
          detail: '',
          life: 3000,
        });
        hasError = true;
      }

      if (!String(this.meetingSubject || '').trim()) {
        this.$toast.add({
          severity: 'error',
          summary: this.$t('ToastComponent.kss.selectSubjectErr'),
          detail: '',
          life: 3000,
        });
        hasError = true;
      }

      if (this.selectedUsers.length === 0
        && this.externalUsers.length === 0) {
        this.$toast.add({
          severity: 'error',
          summary: this.$t('ToastComponent.kss.selectParticipantsErr'),
          detail: '',
          life: 3000,
        });
        hasError = true;
      }

      if (this.reccurringObject !== null && !Array.isArray(this.reccurringObject)) {
        if (this.reccurringObject.isReccuring) {
          if (
            this.reccurringObject.frequency === 'WEEKLY'
            || this.reccurringObject.frequency === 'MONTHLY'
          ) {
            if (!this.reccurringObject.byDayOfWeek?.length) {
              this.$toast.add({
                severity: 'error',
                summary: this.$t('ToastComponent.kss.selectRecurringDays'),
                detail: '',
                life: 3000,
              });
              hasError = true;
            }
          }
        }
      }

      return hasError;
    },
    checkDateAndTimeValid() {
      const selectedDate = new Date(this.selectedDate);
      selectedDate.setHours(this.selectedHours, this.selectedMinutes);

      const currentTime = new Date();
      const timeDifference = currentTime - selectedDate;
      return timeDifference <= 60 * 60 * 1000;
    },
    appendSeriesEndDate(rule, seriesEndDate, hours = this.selectedHours, minutes = this.selectedMinutes) {
      if (!seriesEndDate) {
        return rule;
      }
      const end = new Date(seriesEndDate);
      end.setHours(hours ?? 0, minutes ?? 0, 0, 0);
      rule.end = end.toUTCString();
      return rule;
    },
    buildRepeatRules(dateTaskBegin, options = {}) {
      const recurringObject = Object.prototype.hasOwnProperty.call(options, 'recurringObject')
        ? options.recurringObject
        : this.reccurringObject;
      const baseRepeatRules = options.baseRepeatRules ?? this.repeatRules;
      const timeHours = options.timeHours ?? this.selectedHours;
      const timeMinutes = options.timeMinutes ?? this.selectedMinutes;

      if (recurringObject === null) {
        const rule = baseRepeatRules[0]
          ? JSON.parse(JSON.stringify(baseRepeatRules[0]))
          : { frequency: 'MINUTELY' };
        rule.start = dateTaskBegin;
        if (rule.frequency === 'MINUTELY') {
          rule.end = dateTaskBegin;
        }
        return [rule];
      }

      if (!recurringObject.isReccuring) {
        return [{
          frequency: 'MINUTELY',
          start: dateTaskBegin,
          end: dateTaskBegin,
        }];
      }

      const tempReccuringObj = { ...recurringObject };
      const seriesEndDate = tempReccuringObj.seriesEndDate ?? null;
      delete tempReccuringObj.isReccuring;
      delete tempReccuringObj.seriesEndDate;
      delete tempReccuringObj.includeWeekends;

      const rule = {
        ...tempReccuringObj,
        start: dateTaskBegin,
      };
      if (seriesEndDate) {
        this.appendSeriesEndDate(rule, seriesEndDate, timeHours, timeMinutes);
      } else if (Object.prototype.hasOwnProperty.call(rule, 'end')) {
        delete rule.end;
      }

      return [rule];
    },
    getSavedExternalEmails() {
      const invitedIds = new Set((this.createdTask?.involvedUsers || []).map((id) => String(id)));
      return (this.involvedKssUsers || [])
        .filter(
          (u) => u && u.userStatus === 'external' && u.email && invitedIds.has(String(u._id)),
        )
        .map((u) => String(u.email).toLowerCase())
        .sort();
    },
    normalizeRepeatRulesSignature(repeatRules) {
      const rule = repeatRules?.[0];
      if (!rule) return '';
      const normalized = {
        frequency: rule.frequency || 'MINUTELY',
        interval: rule.interval ?? null,
        byDayOfWeek: [...(rule.byDayOfWeek || [])].sort().join(','),
        byWeekOfMonth: rule.byWeekOfMonth ?? null,
        start: rule.start ? new Date(rule.start).toISOString() : null,
        end: rule.end ? new Date(rule.end).toISOString() : null,
      };
      return JSON.stringify(normalized);
    },
    getSavedDateTaskBegin() {
      const anchor = this.editOccurrenceDate || this.anchorDateFromTask(this.createdTask);
      if (!anchor) return null;
      return new Date(
        anchor.getFullYear(),
        anchor.getMonth(),
        anchor.getDate(),
        anchor.getHours(),
        anchor.getMinutes(),
        0,
        0,
      );
    },
    getCurrentDateTaskBegin() {
      if (!this.selectedDate) return null;
      return new Date(
        this.selectedDate.getFullYear(),
        this.selectedDate.getMonth(),
        this.selectedDate.getDate(),
        this.selectedHours,
        this.selectedMinutes,
        0,
        0,
      );
    },
    hasEditChanges() {
      const externalIdSet = new Set(
        (this.involvedKssUsers || [])
          .filter((el) => el.userStatus === 'external')
          .map((el) => String(el._id)),
      );

      const savedDate = this.getSavedDateTaskBegin();
      const currentDate = this.getCurrentDateTaskBegin();
      if (!savedDate || !currentDate) return true;

      const savedRepeatRules = this.buildRepeatRules(savedDate.toUTCString(), {
        recurringObject: null,
        baseRepeatRules: this.createdTask.repeatRules || [{ frequency: 'MINUTELY' }],
        timeHours: savedDate.getHours(),
        timeMinutes: savedDate.getMinutes(),
      });
      const currentRepeatRules = this.buildRepeatRules(currentDate.toUTCString());

      const baselineInternalUsers = sortKssUserIds(
        (this.occurrenceParticipantBaseline || []).filter((id) => !externalIdSet.has(String(id))),
      );
      const currentInternalUsers = sortKssUserIds(
        (this.selectedUsers || []).filter((id) => !externalIdSet.has(String(id))),
      );

      const savedExternal = this.getSavedExternalEmails().join(',');
      const currentExternal = (this.externalUsers || [])
        .map((e) => String(e).toLowerCase())
        .sort()
        .join(',');

      if (String(this.createdTask.name || '').trim() !== String(this.meetingSubject || '').trim()) {
        return true;
      }
      if (String(this.createdTask.description || '').trim()
        !== String(this.meetingDescription || '').trim()) {
        return true;
      }
      if (baselineInternalUsers !== currentInternalUsers) return true;
      if (savedExternal !== currentExternal) return true;
      if (savedDate.getTime() !== currentDate.getTime()) return true;
      if (this.normalizeRepeatRulesSignature(savedRepeatRules)
        !== this.normalizeRepeatRulesSignature(currentRepeatRules)) {
        return true;
      }
      return false;
    },
    showNoChangesHint() {
      this.$toast.add({
        severity: 'info',
        summary: this.$t('ToastComponent.kss.noChanges'),
        detail: '',
        life: 3000,
      });
    },
    async updateKssTask() {
      if (this.isSavingKssUpdate) return;

      if (this.checkForErrors()) {
        return;
      }

      if (!this.hasEditChanges()) {
        this.showNoChangesHint();
        return;
      }

      if (this.taskIsRecurring && !this.seriesIsEnded) {
        this.selectedEditScope = 'occurrence';
        this.showEditScopeDialog = true;
        return;
      }

      await this.performUpdateKssTask('series');
    },
    async confirmEditScopeAndSave() {
      if (this.isSavingKssUpdate) return;
      this.showEditScopeDialog = false;
      await this.performUpdateKssTask(this.selectedEditScope);
    },
    async performUpdateKssTask(editScope) {
      if (this.isSavingKssUpdate) return;
      this.isSavingKssUpdate = true;
      try {
        const dateTaskBegin = new Date(
          this.selectedDate.getFullYear(),
          this.selectedDate.getMonth(),
          this.selectedDate.getDate(),
          this.selectedHours,
          this.selectedMinutes,
        );

        const matchedEvent = this.findTaskEventForSelectedDate();
        const matchedBegin = matchedEvent?.date_eventBegin
          ? new Date(matchedEvent.date_eventBegin)
          : null;
        const openAnchor = this.editOccurrenceDate || this.anchorDateFromTask(this.createdTask);

        // Occurrence: edit the browsed slot when it exists (add-on-future-date), else move from open anchor.
        // One-time (non-recurring): always use the picker date+time — there is no series pattern to protect.
        // Recurring series/future: keep config calendar day so browsing another day does not rewrite SoT start.
        const scheduleDateTaskBegin =
          editScope === 'occurrence' || !this.taskIsRecurring
            ? dateTaskBegin
            : this.getSeriesScheduleDateTaskBegin();
        // ISO avoids toUTCString() locale quirks when the backend compares schedule signatures.
        const repeatRules = this.buildRepeatRules(scheduleDateTaskBegin.toISOString());

        const externalIdSet = new Set(
          (this.involvedKssUsers || [])
            .filter((el) => el.userStatus === 'external')
            .map((el) => String(el._id)),
        );

        let occurrenceAnchor = openAnchor;
        if (editScope === 'occurrence') {
          occurrenceAnchor = matchedBegin || openAnchor;
        } else if (editScope === 'future') {
          // Never use the *new* picker time as fromDate — that truncates the wrong cut.
          // Prefer matched existing slot, else original edit anchor / open card.
          occurrenceAnchor = matchedBegin || openAnchor || dateTaskBegin;
        }

        // Series/future without a roster edit must keep series SoT (not a slot exception view).
        const rosterSource = (!this.participantsTouched && editScope !== 'occurrence')
          ? this.getSeriesParticipantIds()
          : (this.selectedUsers || []);
        const data = {
          seriesId: this.createdTask.seriesId || this.createdTask._id,
          name: String(this.meetingSubject || '').trim(),
          description: this.meetingDescription,
          involvedUsers: rosterSource.filter((el) => !externalIdSet.has(String(el))),
          involvedExternalUsers: this.externalUsers,
          repeatRules,
          editScope,
          occurrenceDate: occurrenceAnchor?.toISOString?.() || undefined,
        };
        await this.$store.dispatch('updateKssTask', data);

        await this.$store.dispatch('getCreatedTasks');

        this.showContainer = false;
        this.participantsTouched = false;
        this.loadExternalEmailsFromInvolved();
        this.$toast.add({
          severity: 'success',
          summary: this.$t('ToastComponent.kss.kssUpdated', { text: this.featureName }),
          detail: '',
          life: 3000,
        });
      } catch (error) {
          this.$toast.add({
            severity: 'error',
            summary: error.response?.data?.message,
            detail: '',
            life: 3000,
          });
      } finally {
        this.isSavingKssUpdate = false;
      }
    },
    async onPopupConfirm() {
      const data = {
        seriesId: this.createdTask.seriesId || this.createdTask._id,
      };
      try {
        await this.$store.dispatch('deleteKssTask', data);
        this.showPopup = false;
        this.$toast.add({
          severity: 'success',
          summary: this.$t('KssTaskCreatedComponent.toast.successfulDelete', { text: this.featureName }),
          detail: '',
          life: 3000,
        });
      } catch (error) {
        this.$toast.add({
          severity: 'error',
          summary: this.$t('KssTaskCreatedComponent.toast.errorDelete', { text: this.featureName }),
          detail: '',
          life: 3000,
        });
      }
    },
    getFormattedDate(date) {
      return this.formatCalendarDay(new Date(date));
    },
    isCancelledTaskEvent(taskEvent) {
      return taskEvent.status === 'removed_from_series';
    },
    async handleCancelledTaskEventsAction(taskEvent) {
      try {
        const index = this.currentTaskEvents.findIndex(
          (t) => t._id === taskEvent._id,
        );
        if (index < 0) return;

        let message = this.$t('KssTaskCreatedComponent.toast.successfulCancelDate', { text: this.featureName });
        if (this.currentTaskEvents[index].status === 'scheduled') {
          this.currentTaskEvents[index].status = 'removed_from_series';
        } else {
          message = this.$t('KssTaskCreatedComponent.toast.successfulScheduleDate', { text: this.featureName });
          this.currentTaskEvents[index].status = 'scheduled';
        }

        await this.$store.dispatch('updateTaskEventsStatus', {
          assessmentId: taskEvent._id,
          status: this.currentTaskEvents[index].status,
        });
        this.$toast.add({
          severity: 'success',
          summary: message,
          detail: '',
          life: 3000,
        });
      } catch (error) {
        this.$toast.add({
          severity: 'error',
          summary: this.$t('KssTaskCreatedComponent.toast.errorDelete', { text: this.featureName }),
          detail: '',
          life: 3000,
        });
      }
    },
  },
};
</script>

<style scoped>
.task-card__disabled {
  background: var(--color-light-grey) !important;
}

.task-item__disabled .time-rubber {
  background: var(--color-light-grey) !important;
}

.task-item__disabled .time-rubber p,
.task-item__disabled .time-rubber i,
.task-item__disabled label {
  color: var(--color-disabled) !important;
}
</style>
